export default "__VITE_ASSET__50eabf0d__"